<div
  class="flex items-center justify-center overflow-visible pb-0 pt-1"
  role="img"
  [attr.aria-label]="title + ' pie chart'"
>
  <apx-chart
    [series]="chartOptions.series"
    [chart]="chartOptions.chart"
    [labels]="chartOptions.labels"
    [plotOptions]="chartOptions.plotOptions"
    [responsive]="chartOptions.responsive"
    [title]="chartOptions.title"
    [legend]="chartOptions.legend"
    [colors]="chartOptions.colors"
    [stroke]="chartOptions.stroke"
    [grid]="chartOptions.grid"
    [dataLabels]="chartOptions.dataLabels"
  ></apx-chart>
</div>

